export const QUERY_KEYS = {
  TEAM_MEMBERS: 'team-members',
  ADMINS: 'admins',
  NOTES: 'notes',
  NOTE: 'note',
  FEEDBACK_CYCLES: 'feedback-cycles',
  SURVEYS: 'surveys',
  SPIDER_GRAPH: 'spider-graph',
  SCALES: 'scales',
  ADMIN_FEEDBACK_CYCLE: 'admin-feedback-cycle',
  ADMIN_FEEDBACK_CYCLES: 'admin-feedback-cycles',
  ADMIN_FEEDBACK_ENTRIES: 'admin-feedback-entries',
};
